<script lang="ts">
    import { onMount } from "svelte";
    import { Link } from "svelte-navigator";
    import type { CartProduct } from "../model";
    import { api, cart } from "../stores";
    import CartPreviewItem from "./CartPreviewItem.svelte";

    let totalPrice: number = 0;

    $: cartCount = $cart.count;
    $: cartList = $cart.list;

    let typeCart = "shoppingList";

    onMount(async () => {
        await refreshTotalPrice($cartList);
        cartList.subscribe(async (list) => {
            await refreshTotalPrice(list);
        });
    });

    async function refreshTotalPrice(list: CartProduct[]) {
        totalPrice = 0;
        let mirrorTotalPrice = 0;
        for (const p of list) {
            if (p.price && p.quantity) {
                if (p.cartType === typeCart) {
                    mirrorTotalPrice = mirrorTotalPrice + Number(p.price);
                    mirrorTotalPrice = Math.round(mirrorTotalPrice * 100) / 100;
                }
            }
        }
        totalPrice = mirrorTotalPrice;
    }
</script>

<!-- CART PREVIEW -->
<div class="cart-preview">
    <!-- HEADER  -->
    <div class="header-cart">
        <span class="icon">
            <i class="fas fa-shopping-bag" />
        </span>

        <h1>Mon panier</h1>

        {#if $cartCount > 0 ? $cartCount.toString() : null}
            <div class="cart-counter">
                {$cartCount}
            </div>
        {/if}
    </div>

    <div class="product-list">
        {#each $cartList as product (product.uid)}
            {#if product.uid && product.cartType == typeCart}
                <CartPreviewItem productCart={product} />
            {/if}
        {/each}
    </div>

    <div class="bottom-cart">
        <div class="total-price right">
            Total : {totalPrice.toFixed(2).replace(".", ",")} <sup>€</sup><br />
        </div>
        <div class="see-cart right">
            <Link to="cart">
                <div class="link-cart">voir mon panier</div>
            </Link>
        </div>
    </div>
</div>

<style lang="scss">
    @import "../styles/variables.scss";

    .header-cart {
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: center;
        border-bottom: solid 1px $grey-light;

        h1, span {
            font-size: 20px;
        }
        .cart-counter {
            background-color: $dark-mauve;
            border-radius: 50%;
            color: white;
            height: 25px;
            width: 25px;
            text-align: center;
        }
    }

    .product-list {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .bottom-cart {
        display: flex;
        flex-direction: column;
        width: 100%;
        align-self: flex-end;
        .right {
            margin-left: auto;
        }
        .total-price {
            font-family: "Diagramm Bold";
            font-size: 24px;
            letter-spacing: -1px;
        }

        .link-cart {
            text-decoration: underline !important;
            color: $dark-black !important;
        }
    }
</style>
